<template>
    <chooser class="budget-chooser"
             v-model="innerValue"
             :options="options"
             :allow-dynamic="true"
             dynamic-default-text="(enter number)"
             :dynamic-default-value="0"
             title="Do you have a budget in mind?"
             @input="onInput" />
</template>

<script>

import SpecialistChooser from './specialist-chooser'

export default {

    mixins: [
        SpecialistChooser,
    ],

    computed: {

        budgetChoices() {
            return this.$scheme.budgetChoices
        },

        /**
         * @returns {Array<{text: string, value: number}>}
         */
        options() {
            return [
                this.budgetChoices.lower,
                this.budgetChoices.mid,
                { text: `Unlimited`, value: Number.MAX_VALUE },
            ]
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-chooser\_budget-chooser.scss

</style>
